import React, { useEffect, useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Lock, Trophy } from 'lucide-react';
import * as Icons from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Compact achievement strip used on the Paper trading page.
 * Renders all 9 achievements with locked/unlocked styling.
 */
const AchievementsStrip = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/paper/achievements`, { withCredentials: true })
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]));
  }, []);

  if (!items.length) return null;
  const unlockedCount = items.filter((a) => a.unlocked).length;

  return (
    <Card className="mb-6" data-testid="achievements-strip">
      <CardContent className="p-4">
        <div className="flex items-center gap-2 mb-3">
          <Trophy size={16} className="text-yellow-500" />
          <h3 className="font-semibold text-sm">Achievements · {unlockedCount}/{items.length}</h3>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-9 gap-2">
          {items.map((a) => {
            const Icon = Icons[a.icon] || Lock;
            return (
              <div
                key={a.id}
                title={`${a.label} — ${a.description}${a.unlocked ? ' (unlocked)' : ''}`}
                className={`flex flex-col items-center gap-1 p-2 rounded-lg border text-center transition-all ${
                  a.unlocked
                    ? 'bg-gradient-to-br from-purple-50 to-indigo-50 border-purple-300 text-purple-700'
                    : 'bg-gray-50 border-gray-200 text-gray-400'
                }`}
                data-testid={`achievement-${a.id}`}
              >
                <Icon size={20} />
                <span className="text-[10px] font-medium leading-tight">{a.label}</span>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default AchievementsStrip;
